import ApiCore from '../../../services/api/utilities/core'
import apiProvider from '../../../services/api/utilities/provider'

const url = 'company-users'
const plural = 'users'
const single = 'user'

// plural and single may be used for message logic if needed in the ApiCore class.
const apiCompanyUsers = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  delete: true,
  url,
  plural,
  single,
})

apiCompanyUsers.updateProfile = (id, data) =>
  apiProvider.patch(url, `profile/${id}`, data)

apiCompanyUsers.getEmailConfiguration = ({ params }) =>
  apiProvider.getSingle(url, `email-configuration`, { params })

apiCompanyUsers.updateEmailUserNotificationsRules = (data) =>
  apiProvider.patch(url, `email-configuration`, data)

apiCompanyUsers.getCompanyUsersByRole = ({ params }) =>
  apiProvider.getAll(`${url}/role`, { params })

apiCompanyUsers.checkIsUserHrManager = () =>
  apiProvider.getSingle(url, `is-hr-manager`)

apiCompanyUsers.checkNotAdminUser = () =>
  apiProvider.getSingle(url, `check-not-admin`)

apiCompanyUsers.getPaginated = ({ params }) =>
  apiProvider.getAll(`${url}/paginate`, { params })

export default apiCompanyUsers
